const roleManagementTableItems = [
    { title: "Name", key: "RoleName", order: 1, isCheckBox: false, isDate: false, maxWidth: "unset", fw: "500" },
    { title: "Description", key: "Description", order: 2, isCheckBox: false, isDate: false, maxWidth: "400px", fw: "unset" },
    { title: "Category", key: "RoleCategory", order: 3, isCheckBox: false, isDate: false, maxWidth: "100px", fw: "unset" },
    { title: "Protected", key: "IsProtected", order: 4, isCheckBox: true, isDate: false, maxWidth: "unset", fw: "unset" },
    { title: "Created by", key: "CreatedBy", order: 5, isCheckBox: false, isDate: false, maxWidth: "150px", fw: "unset" },
    { title: "Created date", key: "CreatedDate", order: 6, isCheckBox: false, isDate: true, maxWidth: "unset", fw: "unset" },
]

export default roleManagementTableItems